/**
 * @prettier
 */

import CustomizeButton from './CustomizeButton';
import MaxSamplesHint from './MaxSamplesHint';
import PLPTile from './PLPTile';
import PhotoUpload from './PhotoUpload';
import Toggle from './Toggle';
import ToggleLabel from './ToggleLabel';
import TutorialModal from './TutorialModal';
import TutorialModalEntry from './TutorialModalEntry';

export default {
  CustomizeButton,
  MaxSamplesHint,
  PLPTile,
  ...PhotoUpload,
  Toggle,
  ToggleLabel,
  TutorialModal,
  TutorialModalEntry,
};



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/MultiSample/MultiSample.jsx